import type {SxProps, Theme} from '@mui/material'

// MUI ships light-theme colours and reads them from its own palette, which
// this app never populates — it themes by setting data-bs-theme on <html>, so
// a MUI default renders light-mode inside a dark page. Every Autocomplete in
// the scheduler is therefore skinned with Bootstrap custom properties, and
// shares these two objects so the pickers can't drift apart.

/** Input, outline and adornment colours. Set your own `width` alongside it. */
export const AUTOCOMPLETE_SX: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    backgroundColor: 'var(--bs-gray-100)',
    color: 'var(--bs-gray-800)',
    fontSize: '0.95rem',
    borderRadius: '0.475rem',
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'var(--bs-gray-600)',
    opacity: 1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--bs-gray-300)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--bs-gray-400)',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--bs-primary)',
  },
  '& .MuiSvgIcon-root': {
    color: 'var(--bs-gray-600)',
  },
  '& .MuiInputLabel-root': {
    color: 'var(--bs-gray-600)',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--bs-primary)',
  },
  '& .Mui-disabled': {
    color: 'var(--bs-gray-500)',
    WebkitTextFillColor: 'var(--bs-gray-500)',
  },
}

/** The dropdown surface — pass as `componentsProps`. */
export const AUTOCOMPLETE_PAPER_PROPS = {
  paper: {
    sx: {
      backgroundColor: 'var(--bs-body-bg)',
      color: 'var(--bs-gray-800)',
      border: '1px solid var(--bs-gray-300)',
      borderRadius: '0.475rem',
      boxShadow: 'var(--bs-dropdown-box-shadow, 0 0 30px rgba(0,0,0,0.3))',
      '& .MuiAutocomplete-option': {fontSize: '0.925rem'},
      '& .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: 'var(--bs-gray-200)',
      },
      '& .MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: 'var(--bs-primary-light)',
        color: 'var(--bs-primary)',
      },
      '& .MuiAutocomplete-groupLabel': {
        backgroundColor: 'var(--bs-body-bg)',
        color: 'var(--bs-gray-500)',
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        lineHeight: '2rem',
      },
      '& .MuiAutocomplete-noOptions': {color: 'var(--bs-gray-600)'},
    },
  },
}
